// TODO format these imports.
import styled from "styled-components";
import {MutableRefObject, useEffect, useMemo, useRef, useState} from "react";
import React from "react";
import { useLocation } from "react-router-dom";
import './style.scss'
import HomeAnimation from "./HomeAnimation";
import {Subtext} from "../../component/Subtext";
import useBoundingClientRect from "../../hooks/useBoundingClientRect";
import {PROJECT_THEME} from "../../theme";
import ProcessFlow from "../../component/ProcessFlow";
import {Section, SectionHeading} from "../../component/Section";
import {ArticleSection} from "../../component/Article";
import FAQSection from "../../component/FAQ";
import ContactForm from "../../component/ContactForm";
import SERVICES from "../../content/services";
import { BRIEFING_ARTICLES, PORTFOLIO_ARTICLES } from "../../content/articles";
import Link from "../../component/Link";
import useThemedIcon from "../../hooks/useThemedIcon";

const TitleAndCTAWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    /* Was a fixed half of the physical screen height, which left a phone-sized
       hero mostly empty; this keeps the proportions without the dead space. */
    min-height: clamp(14rem, 45vh, 30rem);
`;

const HeroTitleRow = styled.div`
    margin-bottom: 0.5em;
`

const HeadingText = styled.span`
    display: inline-flex;
    align-items: flex-end;
    column-gap: 0.2em;
`

const HeroTitle = styled.h1`
    display: inline;
    color: ${({ theme }) => theme.colour.OFF_WHITE};
`

const ServiceBleed = styled.div`
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 3rem;
`;

const ServiceBand = styled.div`
    display: grid;
    grid-template-columns: 2.25fr 1fr;
    gap: 2.5rem;
    padding: 2.5rem;
    border: 1px solid ${({theme}) => theme.colour.LIGHT_GREY};
    border-radius: ${({theme}) => theme.BORDER_RADIUS};
    background: ${({theme}) => theme.colour.DARK_GREY};

    @media (max-width: 88rem) {
        grid-template-columns: 1fr;
        gap: 1.5rem;
        padding: 1.75rem;
    }
`;

const ArticleBox = styled.div`
    border: 1px solid ${({theme}) => theme.colour.LIGHT_GREY};
    border-radius: ${({theme}) => theme.BORDER_RADIUS};
    background: ${({theme}) => theme.colour.DARK_GREY};
    overflow: hidden;
`;

const ServiceBandAnimBox = styled.div`
    min-width: 0;
    height: 28rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 88rem) {
        height: 22rem;
    }
`;

const ServiceBandPanel = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.5rem;
`;

const ServiceBandTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
`;

const ServiceBandTitle = styled.h1`
    color: ${({theme}) => theme.colour.OFF_WHITE};
    font-family: ${({theme}) => theme.font.FONT_SERIF_ROBOTO_SERIF};
    font-weight: 700;
    font-size: 2rem;
    line-height: 1.15;
    margin: 0;
`

const ServiceBandDescription = styled.p`
    font-size: 0.95em;
    font-family: ${({theme}) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-weight: 400;
    line-height: 1.55;
    color: ${({theme}) => theme.colour.OFF_WHITE};
    margin: 0;
`

const ServiceBandArticleList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-top: 0.1rem;
`

const ServiceBandArticleLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    width: fit-content;
    color: ${({theme}) => theme.colour.COLOUR_LIGHT};
    font-family: ${({theme}) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-size: 0.8em;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-decoration: none;
    transition: color 140ms ease, transform 140ms ease;

    &:hover {
        color: ${({theme}) => theme.colour.OFF_WHITE};
        transform: translateX(2px);
    }
`

const ServiceBandArticleIcon = styled.span`
    flex-shrink: 0;
    width: 0.85rem;
    height: 0.85rem;
    background: ${({theme}) => theme.colour.OFF_WHITE};
    opacity: 0.9;
    -webkit-mask: url(/assets/img/link.svg) center / contain no-repeat;
    mask: url(/assets/img/link.svg) center / contain no-repeat;
`

const ServiceBandFooterRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    margin-top: 0.4rem;
    padding-top: 1rem;
`

const ServiceBandTagDivider = styled.div`
    width: 100%;
    height: 1px;
    background: rgba(96, 96, 104, 0.4);
`

const ServiceBandTagRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.6rem;
    min-width: 0;
`

const ServiceBandTag = styled.img`
    height: 1.7rem;
    width: auto;
    display: inline-block;
    vertical-align: middle;
    object-fit: contain;
    flex-shrink: 0;
    opacity: 0.85;
`

const ServiceTag = ({ src }: { src: string }) => <ServiceBandTag src={useThemedIcon(src)} alt="" />;

const ServiceBandCTA = styled.a`
    display: inline-flex;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    white-space: nowrap;
    padding: 0.7rem 1rem;
    border: 1px solid ${({theme}) => theme.colour.COLOUR_LIGHT};
    border-radius: 4px;
    background: transparent;
    color: ${({theme}) => theme.colour.COLOUR_LIGHT};
    font-family: ${({theme}) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-size: 0.82em;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    text-decoration: none;
    transition: color 140ms ease, border-color 140ms ease, transform 140ms ease;

    &:hover {
        color: ${({theme}) => theme.colour.OFF_WHITE};
        border-color: ${({theme}) => theme.colour.OFF_WHITE};
        transform: translateY(-1px);
    }
`

/* The page gutter is owned by SteppedPage; sections just fill the column it leaves. */
const ROOT_MAX_WIDTH = '100%';

const ProcessFlowWrapper = styled.div`
    width: 100%;
    max-width: ${ROOT_MAX_WIDTH};
    margin: 1.5rem auto 0;
    position: relative;
    z-index: 3;
    padding: 0;
    box-sizing: border-box;
`


// want to add an open source section.
const Home = () => {

    const [gridPositions, setGridPositions] = useState<DOMRect[]>([])
    const rfpRef = useRef<HTMLDivElement | null>(null);
    const [flowChartRect, setFlowChartRect] = useBoundingClientRect()
    const [processGridRect, setProcessGridRect] = useBoundingClientRect()
    const flowChartNodeRefs = useRef<MutableRefObject<HTMLDivElement | null>[]>(Array.from({length: 8}, () => React.createRef<HTMLDivElement>()));
    const CTALogoRef = useRef<HTMLAnchorElement>(null)

    const footerFooterRef = useRef<HTMLElement | null>(null);
    const location = useLocation();

    useEffect(() => {
        footerFooterRef.current = document.getElementById('footer-footer');
        document.querySelector('.react-flow__attribution')?.remove();
    }, []);

    // Lets nav links like "/#services" and "/#contact" work from any page, since
    // client-side route changes don't get the browser's native scroll-to-fragment.
    useEffect(() => {
        if (!location.hash) return;
        document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    }, [location.hash]);

    const scrollToContact = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const target = rfpRef.current;
        if (!target) return;
        event.preventDefault();
        window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - PROJECT_THEME.dimensions.NAVBAR_HEIGHT,
            behavior: 'smooth',
        });
    };


    return (
        <>
            <TitleAndCTAWrapper>
                <HeroTitleRow>
                    <HeroTitle>Years in weeks</HeroTitle>
                </HeroTitleRow>
                <Subtext>
                    Professional, stack-agnostic software engineering
                </Subtext>
            </TitleAndCTAWrapper>
            <SectionHeading color={PROJECT_THEME.colour.COLOUR_LIGHT} contentWidth={ROOT_MAX_WIDTH} weight={900} markerSize="0.71em">
                <HeadingText data-physics-clear>
                    {"Start a project"}
                    <Link scrollTo={rfpRef}/>
                </HeadingText>


            </SectionHeading>
            <Section id="services" headless expand>
                <ServiceBleed data-physics-spawn>
                    {[...SERVICES].reverse().map((service: any) => {
                        const {
                            title,
                            tags,
                            shortDescription,
                            relatedArticles,
                            ServiceCardContent,
                            ctaText
                        } = service;

                        return (
                            <ServiceBand key={title} data-physics>
                                <ServiceBandAnimBox>
                                    {ServiceCardContent && <ServiceCardContent/>}
                                </ServiceBandAnimBox>
                                <ServiceBandPanel>
                                    <ServiceBandTop>
                                        <ServiceBandTitle>
                                            {title}
                                        </ServiceBandTitle>
                                        <ServiceBandDescription>
                                            {shortDescription}
                                        </ServiceBandDescription>
                                        {relatedArticles && relatedArticles.length > 0 && (
                                            <ServiceBandArticleList>
                                                {relatedArticles.slice(0, 3).map((article: { title: string; url: string }) => (
                                                    <ServiceBandArticleLink
                                                        key={`${title}-${article.url}-${article.title}`}
                                                        href={article.url}
                                                    >
                                                        <ServiceBandArticleIcon aria-hidden />
                                                        <span>{article.title}</span>
                                                    </ServiceBandArticleLink>
                                                ))}
                                            </ServiceBandArticleList>
                                        )}
                                    </ServiceBandTop>
                                    <ServiceBandFooterRow>
                                        <ServiceBandCTA href="#contact" onClick={scrollToContact}>
                                            {ctaText ?? 'Start a project'}
                                        </ServiceBandCTA>
                                        <ServiceBandTagDivider />
                                        <ServiceBandTagRow>
                                            {tags.slice(0, 8).map((iconPath: string) => (
                                                <ServiceTag key={`${title}-${iconPath}`} src={iconPath} />
                                            ))}
                                        </ServiceBandTagRow>
                                    </ServiceBandFooterRow>
                                </ServiceBandPanel>
                            </ServiceBand>
                        );
                    })}
                </ServiceBleed>
            </Section>
            <Section color={PROJECT_THEME.colour.COLOUR_MID_LIGHT} title='process' expand>
                <ProcessFlowWrapper>
                    <ProcessFlow />
                </ProcessFlowWrapper>
            </Section>
            <Section
                title="briefing"
                color={PROJECT_THEME.colour.COLOUR_MID}
                expand
            >
                <ArticleBox>
                    <ArticleSection data-physics articles={BRIEFING_ARTICLES} edge={11} direction="left" rate={0.4} />
                </ArticleBox>
            </Section>

            <Section
                title="portfolio"
                color={PROJECT_THEME.colour.COLOUR_MID_DARK}
                expand
            >
                <ArticleBox>
                    <ArticleSection data-physics articles={PORTFOLIO_ARTICLES} edge={11} direction="left" rate={0.72} />
                </ArticleBox>
            </Section>

            <Section color={PROJECT_THEME.colour.COLOUR_LIGHT} title={'FAQ'} expand>
                <FAQSection>
                    {
                        {
                            'What kinds of projects do you typically take on?': { meta: 'scope', answer: 'We usually partner on platform engineering, cloud architecture, AI integration, data systems, and product-focused custom software builds. We can work on greenfield initiatives as well as modernization programs for existing systems.' },
                            'Can you work with our existing team instead of replacing it?': { meta: 'teams', answer: 'Yes. Most engagements are collaborative. We can embed with your engineering and product teams, help unblock delivery, improve architecture decisions, and transfer knowledge so your team stays self-sufficient.' },
                            'How long does a typical engagement last?': { meta: 'timeline', answer: 'It depends on scope. Discovery and technical planning can take 1 to 3 weeks, while delivery phases usually run from 6 to 16 weeks. For larger programs, we plan phased milestones so value is delivered continuously.' },
                            'How do you price projects?': { meta: 'pricing', answer: 'We support fixed-scope phases for clearly defined outcomes and time-and-material models for evolving programs. Pricing is transparent, with clear deliverables, assumptions, and regular reporting on progress and budget burn.' },
                            'Do you handle security and compliance requirements?': { meta: 'security', answer: 'Yes. We design with security from the start, including threat-aware architecture, CI/CD guardrails, and operational controls. We can align implementation to common compliance expectations such as SOC 2, PCI, and internal governance standards.' },
                            'What does communication look like during delivery?': { meta: 'delivery', answer: 'We keep communication lightweight and consistent: weekly planning/check-ins, concise status updates, and shared visibility into risks, decisions, and progress. You always know what is shipped, what is next, and what is blocked.' },
                            'Do you provide support after launch?': { meta: 'support', answer: 'Absolutely. We offer post-launch stabilization, observability tuning, performance optimization, and handover documentation. If needed, we can stay involved through a retained support model while your team takes ownership.' },
                        }
                    }
                </FAQSection>
            </Section>
            <Section id="contact" ref={rfpRef} headless expand>
                <ContactForm/>
            </Section>
            <HomeAnimation/>
        </>

    );
}
export default Home;
